// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import { Turbo } from "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"

Rails.start()
ActiveStorage.start()
// 停用 Turbo Drive：本 app 為傳統 jQuery/jstree 架構（jquery-ujs + .js.erb remote），
// turbo 的局部導航會讓查詢/列表的 jQuery 初始化不重跑而頁面空白（需手動刷新才有資料）。
// 停用後所有導航走傳統完整載入，jQuery 每次正常初始化、.js.erb 由 ujs 處理。
Turbo.session.drive = false
require("channels")
require('bootstrap')
require("flatpickr/dist/themes/dark.css");
require('jquery')
require("@fortawesome/fontawesome-free/js/all")

import $ from 'jquery';
global.$ = $
global.jQuery = $

document.addEventListener("turbo:load", () => {
    $('[data-tooltip-display="true"]').tooltip(),
    $('[data-toggle="popover"]').popover(),
    flatpickr("[class='flatpickr']", {})
})


import 'stylesheets/application.css';
import '../sweet-alert-confirm';

import 'bootstrap/scss/bootstrap';
import "flatpickr/dist/flatpickr";
import "tailwindcss/dist/tailwind.css";


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

